// Navegación a un acceso de menú.
//
// Algunas rutas necesitan un state de navegación o limpiar un filtro guardado antes de entrar.
// Esas reglas ya existían dentro de Container_List (el menú anterior); aquí viven en un helper
// para que cualquier menú pueda reutilizarlas sin duplicarlas.
//
// Mientras el menú anterior siga en uso, Container_List conserva su propia copia a propósito:
// así el rediseño no puede romper la pantalla que está en producción. Cuando el nuevo menú quede
// aprobado, Container_List puede importar este helper y borrar su copia.
//
// Creado: 2026-09-17 — IA (Claude)

// Sucursales con las que entra la Cartera de Clientes desde el menú.
const SUCURSALES_CARTERA_CLIENTES = [
  { idsucursal: 1 },
  { idsucursal: 2 },
  { idsucursal: 11 },
  { idsucursal: 12 },
  { idsucursal: 21 },
  { idsucursal: 22 },
  { idsucursal: 31 },
  { idsucursal: 32 },
  { idsucursal: 41 },
  { idsucursal: 42 },
  { idsucursal: 51 },
  { idsucursal: 52 },
  { idsucursal: 61 },
];

export const navegarAcceso = (history, ruta) => {
  if (!history || typeof ruta !== "string" || !ruta.startsWith("/")) return;

  if (ruta === "/Credito/CarteraClientes") {
    history.push(ruta, {
      permisos: SUCURSALES_CARTERA_CLIENTES,
      filtro: "C",
      ruta: "C",
    });
    return;
  }

  if (ruta === "/Postventa/Dashboard") {
    history.push(ruta, {
      sucursales: "",
      adr: "",
      ejercicio: new Date().getFullYear(),
      periodo_inicio: new Date().getMonth() + 1,
      periodo_fin: new Date().getMonth() + 1,
      regresar: false,
    });
    return;
  }

  if (ruta === "/Ventas/Cotizaciones") {
    try {
      localStorage.removeItem("filtrosCotizaciones");
    } catch (error) {
      // Sin acción: el filtro guardado es opcional.
    }
  }

  history.push(ruta);
};

export default navegarAcceso;
